<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="copyright1"><a id="page_iv"></a>Henry Holt and Company, LLC</p>
<p class="copyright"><em>Publishers since 1866</em></p>
<p class="copyright">175 Fifth Avenue</p>
<p class="copyright">New York, New York 10010</p>
<p class="copyright"><a href="http://www.HenryHoltKids.com" target="_blank">www.HenryHoltKids.com</a></p>
<p class="copyright1">Henry Holt<sup>®</sup> is a registered trademark of Henry Holt and Company, LLC.</p>
<p class="copyright">Copyright © 2009 by Marissa Doyle</p>
<p class="copyright">All rights reserved.</p>
<p class="copyright">Distributed in Canada by H. B. Fenn and Company Ltd.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Doyle, Marissa.</p>
<p class="copyright">Betraying season / Marissa Doyle.—1st ed.</p>
<p class="copyright">p.    cm.</p>
<p class="copyright">Summary: In 1838, Penelope Leland goes to Ireland to study magic and prove to herself that she is as good a witch as her twin sister Persy, but when Niall Keating begins to pay her court, she cannot help being distracted.</p>
<p class="copyright">ISBN-13: 978-0-8050-8252-4</p>
<p class="copyright">ISBN-10: 0-8050-8252-2</p>
<p class="copyright">[1. Witches—Fiction. 2. Magic—Fiction. 3. Courtship—Fiction. 4. Ireland—History—1837–1901—Fiction. 5. Great Britain—History—Victoria, 1837–1901—Fiction.] I. Title.</p>
<p class="copyright">PZ7.D7758Bet 2009</p>
<p class="copyright">[Fic]—dc22</p>
<p class="copyright">2008040593</p>
<p class="copyright1">First Edition—2009</p>
<p class="copyright">Printed in the United States of America on acid-free paper.∞</p>
<p class="copyright1">1   3   5   7   9   10   8   6   4   2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?47a690a8